import isEmpty from '../../../../../../utils/objectchecking/IsEmpty';
import { sendWebsocketMessage } from '../../../../../../App';

export function addExitTactic(tradePlanId, tactic) {
  if (
    isEmpty(tactic) ||
    tactic.details === undefined ||
    isEmpty(tactic.details)
  ) {
    return;
  }
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'addExitTactic',
    value: tactic,
  };
  sendWebsocketMessage(msg);
}
